import React from 'react';
import { Box, Typography, Paper, Chip } from '@mui/material';

// Format focus area code to readable text
const formatFocusArea = (code) => {
    const mapping = {
        'ST_VOICE': 'Voice',
        'ST_IMAGERY': 'Imagery',
        'ST_STRUCTURE': 'Structure',
        'ST_COHERENCE': 'Coherence',
        'ST_DEVELOPMENT': 'Development',
        'ST_TRANSITION': 'Transition',
    };
    return mapping[code] || code;
};

// Format issue type code to readable text
const formatIssueType = (code) => {
    const mapping = {
        'IM_GRAMMAR': 'Grammar',
        'IM_CLARITY': 'Clarity',
        'IM_CONCISION': 'Concision',
        'IM_LOGIC': 'Logic',
        'IM_PROMPT_FIT': 'Prompt Fit',
        'IM_DEPTH': 'Depth',
        'IM_COHERENCE': 'Coherence',
    };
    return mapping[code] || code;
};

const CommentCard = ({
    id,
    item,
    type,
    isActive,
    isHovered,
    onClick,
    onMouseEnter,
    onMouseLeave,
    colors,
    compact = false,
}) => {
    const isStrength = type === 'strength';
    const borderColor = isStrength ? colors.blueAccent[400] : colors.redAccent[400];
    const bgColor = isStrength ? colors.blueAccent[900] : colors.redAccent[900];

    const isHighlighted = isActive || isHovered;

    return (
        <Paper
            id={id}
            elevation={isHighlighted ? 6 : 1}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            className={`comment-card ${isActive ? 'active' : ''} ${isHovered ? 'hovered' : ''}`}
            sx={{
                borderLeft: `4px solid ${borderColor}`,
                backgroundColor: `${bgColor}20`,
                p: compact ? 1.5 : 2,
                cursor: 'pointer',
                transform: isActive ? 'scale(1.02)' : isHovered ? 'scale(1.01)' : 'scale(1)',
                boxShadow: isHighlighted ? 6 : 1,
                outline: isHighlighted ? `2px solid ${borderColor}` : 'none',
                transition: 'all 0.2s ease',
                '&:hover': {
                    transform: 'scale(1.01)',
                    boxShadow: 4,
                },
            }}
        >
            {/* Focus Area / Issue Type Chip */}
            <Chip
                label={isStrength ? formatFocusArea(item.focus_area) : formatIssueType(item.issue_type)}
                size="small"
                color={isStrength ? 'info' : 'error'}
                sx={{ mb: 1 }}
            />

            {/* Representative Sentence */}
            {/* {item.representative_sentence && (
                <Typography
                    variant="body2"
                    sx={{
                        fontStyle: 'italic',
                        my: 1,
                        color: colors.grey[300],
                        fontSize: compact ? '0.85rem' : '0.9rem',
                    }}
                >
                    "{item.representative_sentence}"
                </Typography>
            )} */}

            {/* Comment */}
            <Typography
                variant="body1"
                sx={{
                    fontSize: compact ? '0.9rem' : '1rem',
                    lineHeight: 1.6,
                }}
            >
                {item.comment}
            </Typography>

            {/* Example Revision (for improvements only) */}
            {item.example_revision && (
                <Box
                    sx={{
                        mt: 1.5,
                        p: 1.5,
                        backgroundColor: `${colors.greenAccent[900]}30`,
                        borderRadius: '4px',
                        borderLeft: `3px solid ${colors.greenAccent[400]}`,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 0.5 }}
                    >
                        Suggested Revision:
                    </Typography>
                    <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                        "{item.example_revision}"
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

export default CommentCard;
